import React from 'react';
import { Button, Grid, Header, Icon, Modal, Popup } from 'semantic-ui-react';

interface LenderInsuranceGeneralConditionProps {
  openModal: boolean;
  toggleOpen: () => void;
  toggleClose: () => void;
}
const LenderInsuranceGeneralConditionModal = (
  props: LenderInsuranceGeneralConditionProps
) => {
  const { openModal, toggleClose, toggleOpen } = props;
  return (
    <>
      <Modal open={openModal} onClose={toggleClose} onOpen={toggleOpen}>
        <Modal.Header>
          <Header>Condições Gerais</Header>
        </Modal.Header>
        <Modal.Content scrolling>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <p>Conheça as condições do produto seguro prestamista.</p>
                <ul>
                  <li>
                    Condições Gerais (
                    <a
                      href="https://s3.us-east-1.amazonaws.com/app.ladobom.com/condicoes_gerais_000_407_11122025_01012999+PRESTAMISTA+CAPITAL+VINCULADO.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                    )
                  </li>

                  <li>
                    Para baixar os termos de adesão, acesse o&nbsp;
                    <a
                      href="https://docs.ladobom.com/produtos/prestamista-capital-vinculado/clausulas-contrato-locacao"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      FAQ
                    </a>
                  </li>
                </ul>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={toggleClose} color={'green'}>
            OK, Entendi
          </Button>
        </Modal.Actions>
      </Modal>

      <Popup
        trigger={
          <span
            onClick={toggleOpen}
            style={{
              color: '#9d9d9d',
              fontWeight: 'bold',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            <Icon
              size={'small'}
              name={'file alternate outline'}
              color={'grey'}
              style={{ cursor: 'pointer', marginRight: '10px', fontSize: 14 }}
            />
            Condições Gerais
          </span>
        }
        content={'Clique aqui para ver as condições gerais'}
        position={'left center'}
      />
    </>
  );
};

export default LenderInsuranceGeneralConditionModal;
